import {
  apiAdminActiveSubscriptionsReport,
  apiAdminDemoReport,
  apiAdminExpiringSubscriptionsReport,
  apiAdminUpdateDemoCall,
  apiAdminUpdateSalesExpert,
  apiAdminUpdateUserCall,
  apiAdminUsersReport,
} from "../api/adminApi";
import {formatPersianDate, formatPrice} from "../helpers";
import {useDispatch, useSelector} from "react-redux";
import {setTableData} from "../store/actions/dataTableAction";
import SettingsBasicSelect from "components/Shared/SettingsBasicSelect";
import {expertOptionConst} from "constants/salesExpertConstant";
import {searchType} from "./FactorForm";

const userReportTableColumns = [
    {
        name: "شناسه",
        key: "id",
        size: "2",
        mainColumn: true,

        navigate: "/management?businessId=",
        navigateKey: (item) => {
            return item.Businesses && item.Businesses[0]
                ? `${item.Businesses[0].id}&firstName=${item.firstName}&lastName=${item.lastName}&businessName=${item.Businesses[0].nickName}`
                : "undefined";
        },
        searchType: searchType.default,
    },
    {
        name: "نام",
        key: "firstName",
        size: "3",
        mainColumn: true,
        searchType: searchType.default,
    },
    {
        name: "نام خانوادگی",
        key: "lastName",
        size: "4",
        mainColumn: true,
        searchType: searchType.default,
    },
    {
        name: "نام کسب و کار",
        key: "nickName",
        size: "4",
        mainColumn: false,
        getValue: (item) => {
            return item.Businesses && item.Businesses[0] ? item.Businesses[0].nickName : "-";
        },
        searchKey: "nickName",
        searchType: searchType.default,
    },
    {
        name: "تلفن",
        key: "phone",
        size: "2",
        mainColumn: true,
    },
    {
        name: "تاریخ ثبت نام",
        key: "createdAt",
        size: "2",
        mainColumn: true,

        getValue: (item) => {
            return item.createdAt ? formatPersianDate(item.createdAt) : "-";
        },
        searchType: searchType.date,
    },
    {
        name: "استفاده از نسخه ویندوز",
        key: "desktopRequest",
        size: "3",
        mainColumn: true,

        getValue: (item) => {
            return item.desktopRequest ? formatPersianDate(item.desktopRequest) : "ندارد";
        },
    },
    {
        name: "آخرین تماس",
        key: "lastCall",
        size: "2",
        mainColumn: true,

        getValue: (item) => {
            return item.lastCall ? formatPersianDate(item.lastCall) : "-";
        },
    },
    {
        name: "به روزرسانی",
        key: "update_last_call",
        size: "2",
        mainColumn: true,

        Component: ({item}) => {
            const dataTable = useSelector((state) => state.dataTableReducer);
            const token = useSelector((state) => state.businessReducer.business?.token);
            const dispatch = useDispatch();

            return (
                <button
                    className={"btn btn-info btn-sm text-white"}
                    onClick={() =>
                        dispatch(
                            apiAdminUpdateUserCall(item.id, token, () => {
                                dataTable.items.find((d) => d.id === item.id).lastCall = new Date();
                                dispatch(setTableData(dataTable.items, dataTable.paginate));
                            })
                        )
                    }
                >
                    به روزرسانی
                </button>
            );
        },
    },
    {
        name: "کارشناس فروش",
        key: "salesExpert",
        size: "2",
        mainColumn: true,

        Component: ({item}) => {
            const dataTable = useSelector((state) => state.dataTableReducer);
            const token = useSelector((state) => state.businessReducer.business?.token);
            const dispatch = useDispatch();

            return (
                // <button
                //   className={"btn btn-info btn-sm text-white"}
                //   onClick={() =>
                //     dispatch(
                //       apiAdminUpdateUserCall(item.id, token, () => {
                //         dataTable.items.find((d) => d.id === item.id).lastCall = new Date();
                //         dispatch(setTableData(dataTable.items, dataTable.paginate));
                //       })
                //     )
                //   }
                // >
                //   به روزرسانی
                // </button>
                <SettingsBasicSelect
                    options={expertOptionConst}
                    onChange={(_, val) => {
                        dispatch(apiAdminUpdateSalesExpert({token, id: item?.id, salesExpert: JSON.stringify(val)}));
                    }}
                    placeholder={item?.salesExpert && JSON?.parse(item?.salesExpert)?.label}

                />
            );
        },
    },
];

const demoReportTableColumns = [
    {
        name: "تلفن",
        key: "phone",
        size: "4",
        mainColumn: true,
    },
    {
        name: "تاریخ استفاده",
        key: "createdAt",
        size: "4",
        mainColumn: true,

        getValue: (item) => {
            return item.createdAt ? formatPersianDate(item.createdAt) : "ندارد";
        },
    },
    {
        name: "آخرین تماس",
        key: "lastCall",
        size: "2",
        mainColumn: true,

        getValue: (item) => {
            return item.lastCall ? formatPersianDate(item.lastCall) : "-";
        },
    },
    {
        name: "به روزرسانی",
        key: "update_last_call",
        size: "2",
        mainColumn: true,

        Component: ({item}) => {
            const dataTable = useSelector((state) => state.dataTableReducer);
            const token = useSelector((state) => state.businessReducer.business?.token);
            const dispatch = useDispatch();

            return (
                <button
                    className={"btn btn-info btn-sm"}
                    onClick={() =>
                        dispatch(
                            apiAdminUpdateDemoCall(item.id, token, () => {
                                dataTable.items.find((d) => d.id === item.id).lastCall = new Date();
                                dispatch(setTableData(dataTable.items, dataTable.paginate));
                            })
                        )
                    }
                >
                    به روزرسانی
                </button>
            );
        },
    },
];

const activeSubscriptionsReportTableColumns = [
    {
        name: "شناسه",
        key: "BusinessId",
        size: "1",
        mainColumn: true,

        navigate: "/management?businessId=",
        navigateKey: (item) => {
            return (
                item.Users &&
                `${item.BusinessId}&firstName=${item.Users[0].firstName}&lastName=${item.Users[0].lastName}&businessName=${item.nickName}`
            );
        },
    },
    {
        name: "نام کسب و کار",
        key: "nickName",
        size: "4",
        mainColumn: true,
    },
    // {
    //     name: "نام قانونی",
    //     key: "legalName",
    //     size: "4",
    //     mainColumn: true,
    //
    // },
    {
        name: "تاریخ ثبت",
        key: "createdAt",
        size: "2",
        mainColumn: false,

        getValue: (item) => {
            return formatPersianDate(item.createdAt);
        },
    },
    {
        name: "تقویم",
        key: "is_gregorian",
        size: "2",
        mainColumn: true,

        getValue: (item) => {
            return item.is_gregorian ? "میلادی" : "شمسی";
        },
    },
    {
        name: "نام",
        key: "firstName",
        size: "2",
        mainColumn: true,

        getValue: (item) => {
            return item.Users && item.Users[0].firstName;
        },
    },
    {
        name: "نام خانوادگی",
        key: "lastName",
        size: "2",
        mainColumn: true,

        getValue: (item) => {
            return item.Users && item.Users[0].lastName;
        },
    },
    {
        name: "تلفن همراه",
        key: "phone",
        size: "2",
        mainColumn: true,

        getValue: (item) => {
            return item.Users && item.Users[0].phone;
        },
    },
    {
        name: "نوع اشتراک",
        key: "subscription",
        size: "2",
        mainColumn: true,

        getValue: (item) => {
            return (
                item.Business_Subscription_Prices &&
                item.Business_Subscription_Prices[0].Subscription_Price.Subscription.title
            );
        },
    },
    {
        name: "مبلغ پرداختی",
        key: "paid",
        size: "2",
        mainColumn: true,
        getValue: (item) => {
            return (
                item.Business_Subscription_Prices &&
                formatPrice(item.Business_Subscription_Prices[0].Online_Payment.price)
            );
        },
    },
    {
        name: "خرید اشتراک",
        key: "start_date",
        size: "2",
        mainColumn: true,
        getValue: (item) => {
            return (
                item.Business_Subscription_Prices &&
                formatPersianDate(item.Business_Subscription_Prices[0].start_date)
            );
        },
    },
    {
        name: "اتمام اشتراک",
        key: "end_date",
        size: "2",
        mainColumn: true,
        getValue: (item) => {
            return (
                item.Business_Subscription_Prices && formatPersianDate(item.Business_Subscription_Prices[0].end_date)
            );
        },
    },
    {
        name: "فعالیت 1 روزه",
        key: "dailyActivities",
        size: "2",
        price: true,
        mainColumn: true,
    },
    {
        name: "فعالیت 3 روزه",
        key: "threeDaysActivities",
        size: "2",
        price: true,
        mainColumn: true,
    },
    {
        name: "فعالیت 7 روزه",
        key: "weeklyActivities",
        size: "2",
        price: true,
        mainColumn: true,
    },
    {
        name: "فعالیت 30 روزه",
        key: "monthlyActivities",
        size: "2",
        price: true,
        mainColumn: true,
    },
    {
        name: "آخرین تماس",
        key: "lastCall",
        size: "2",
        mainColumn: true,

        getValue: (item) => {
            return item.lastCall ? formatPersianDate(item.lastCall) : "-";
        },
    },
    {
        name: "به روزرسانی",
        key: "update_last_call",
        size: "2",
        mainColumn: true,

        Component: ({item}) => {
            const dataTable = useSelector((state) => state.dataTableReducer);
            const token = useSelector((state) => state.businessReducer.business?.token);
            const dispatch = useDispatch();

            return (
                <button
                    className={"btn btn-info btn-sm"}
                    onClick={() =>
                        dispatch(
                            apiAdminUpdateUserCall(item.UserId, token, () => {
                                dataTable.items.find((d) => d.UserId === item.UserId).lastCall = new Date();
                                dispatch(setTableData(dataTable.items, dataTable.paginate));
                            })
                        )
                    }
                >
                    به روزرسانی
                </button>
            );
        },
    },
];

const userActivitiesReportTableColumns = [
    {
        name: "شناسه",
        key: "id",
        size: "1",
        mainColumn: true,

        navigate: "/management?businessId=",
        navigateKey: (item) => {
            return `${item.id}&firstName=${item.firstName}&lastName=${item.lastName}&businessName=${item.nickName}`;
        },
    },
    {
        name: "نام کسب و کار",
        key: "nickName",
        size: "4",
        mainColumn: true,
    },
    {
        name: "تاریخ ثبت",
        key: "createdAt",
        size: "2",
        mainColumn: false,

        getValue: (item) => {
            return formatPersianDate(item.createdAt);
        },
    },
    {
        name: "نام کاربر",
        key: "firstName",
        size: "2",
        mainColumn: true,
    },
    {
        name: "نام خانوادگی",
        key: "lastName",
        size: "2",
        mainColumn: true,
    },
    {
        name: "تلفن همراه",
        key: "phone",
        size: "2",
        mainColumn: true,
    },
    {
        name: "فعالیت 1 روزه",
        key: "dailyActivities",
        size: "2",
        price: true,
        mainColumn: true,
    },
    {
        name: "فعالیت 3 روزه",
        key: "threeDaysActivities",
        size: "2",
        price: true,
        mainColumn: true,
    },
    {
        name: "فعالیت 7 روزه",
        key: "weeklyActivities",
        size: "2",
        price: true,
        mainColumn: true,
    },
    {
        name: "فعالیت 30 روزه",
        key: "monthlyActivities",
        size: "2",
        price: true,
        mainColumn: true,
    },
    {
        name: "آخرین تماس",
        key: "updated_at",
        size: "2",
        mainColumn: true,

        getValue: (item) => {
            return item.lastCall ? formatPersianDate(item.lastCall) : "-";
        },
    },
    {
        name: "به روزرسانی",
        key: "update_last_call",
        size: "2",
        mainColumn: true,

        Component: ({item}) => {
            const dataTable = useSelector((state) => state.dataTableReducer);
            const token = useSelector((state) => state.businessReducer.business?.token);
            const dispatch = useDispatch();

            return (
                <button
                    className={"btn btn-info btn-sm"}
                    onClick={() =>
                        dispatch(
                            apiAdminUpdateUserCall(item.UserId, token, () => {
                                dataTable.items.find((d) => d.UserId === item.UserId).lastCall = new Date();
                                dispatch(setTableData(dataTable.items, dataTable.paginate));
                            })
                        )
                    }
                >
                    به روزرسانی
                </button>
            );
        },
    },
];

export const userReportFormData = [
    {
        key: "userReportTable",
        label: "کاربر",
        pluralLabel: "کاربران",
        title: "همه کاربران",
        pageTitle: "کاربران چرتکه",
        pageDescription: "نمایش کاربران چرتکه",
        tableColumns: userReportTableColumns,
        actions: {
            fetch: apiAdminUsersReport,
        },
    },
    {
        key: "demoReport",
        label: "کاربر",
        pluralLabel: "کاربران",
        title: "کاربران دمو",
        pageTitle: "کاربران دموی چرتکه",
        pageDescription: "نمایش کاربران دموی چرتکه",
        tableColumns: demoReportTableColumns,
        actions: {
            fetch: apiAdminDemoReport,
        },
    },
    {
        key: "activeSubscriptionsReport",
        label: "کاربر",
        pluralLabel: "کاربران",
        title: "اشتراک های فعال",
        pageTitle: "اشتراک های فعال چرتکه",
        pageDescription: "نمایش اشتراک های فعال",
        tableColumns: activeSubscriptionsReportTableColumns,
        hidePagination: true,
        actions: {
            fetch: apiAdminActiveSubscriptionsReport,
        },
    },
    {
        key: "expiringSubscriptionsReport",
        label: "کاربر",
        pluralLabel: "کاربران",
        title: "تمدید",
        pageTitle: "اشتراک های در حال انقضای چرتکه",
        pageDescription: "نمایش اشتراک های نیاز به پیگیری",
        tableColumns: activeSubscriptionsReportTableColumns,
        hidePagination: true,
        actions: {
            fetch: apiAdminExpiringSubscriptionsReport,
        },
    },
    // {
    //     key: "userActivitiesReport",
    //     label: "کاربر",
    //     pluralLabel: 'کاربران',
    //     title: "آمار استفاده",
    //     pageTitle: "گزارش فعالیت کاربران چرتکه",
    //     pageDescription: "نمایش تعداد فعالیت های کاربران",
    //     tableColumns: userActivitiesReportTableColumns,
    //     actions: {
    //         fetch: apiAdminUserActivityReport,
    //     },
    // },
];
